// extracted by mini-css-extract-plugin
export var button = "_e0-4";
export var hasDarkBackground = "_e0-7";
export var hasLightBackground = "_e0-6";
export var iconWrapper = "_e0-0";
export var large = "_e0-2";
export var medium = "_e0-1";
export var small = "_e0-5";
export var xsmall = "_e0-3";